import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

function Payment() {

  const { state } =
    useLocation();

  const navigate =
    useNavigate();

  const pkg =
    state?.package ||
    JSON.parse(
      localStorage.getItem(
        "selectedPackage"
      )
    );

  /* ================= NAVBAR HIDE / TOP SHOW ONLY ================= */

  useEffect(() => {

    const navbar =
      document.querySelector(
        ".navbar"
      );

    const handleScroll = () => {

      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      /* top ekedi show */
      if (currentScroll <= 10) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";
      }

      /* scroll una gaman hide */
      else {

        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";

        navbar.style.opacity =
          "0";
      }
    };

    if (navbar) {

      navbar.style.position =
        "fixed";

      navbar.style.top =
        "15px";

      navbar.style.left =
        "50%";

      navbar.style.width =
        "90%";

      navbar.style.maxWidth =
        "1100px";

      navbar.style.transform =
        "translateX(-50%)";

      navbar.style.zIndex =
        "9999";

      navbar.style.transition =
        "all 0.35s ease";
    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";
      }
    };

  }, []);

  /* ================= PACKAGE CHECK ================= */

  useEffect(() => {

    if (!pkg) {
      navigate("/mcq");
    }

  }, [pkg, navigate]);

  if (!pkg) {
    return (
      <p style={{ padding: 40 }}>
        No package selected
      </p>
    );
  }

  /* ================= PAY NOW ================= */

  const handlePayNow = () => {

    const user = JSON.parse(
      localStorage.getItem("user")
    );

    /* not login */
    if (!user) {

      localStorage.setItem(
        "redirect_after_login",
        "/profile"
      );

      navigate("/auth");
      return;
    }

    /* after payment */
    navigate("/profile");

  };

  return (

    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#e5e7eb",
      }}
    >

      <div
        style={{
          background: "#fff",
          padding: 30,
          width: 360,
          borderRadius: 20,
          boxShadow:
            "0 20px 50px rgba(0,0,0,0.2)",
        }}
      >

        <h2>
          Demo Payment
        </h2>

        <p>
          <b>Subject:</b>
          {" "}OL Sinhala
        </p>

        <p>
          <b>Teacher:</b>
          {" "}Mr. Silva
        </p>

        <p>
          <b>Package:</b>
          {" "}{pkg.title}
        </p>

        <p>
          <b>Amount:</b>
          {" "}Rs. {pkg.price}
        </p>

        <div
          style={{
            marginTop: 16,
            background:
              "#fff7ed",
            padding: 12,
            borderRadius: 10,
            color: "#c2410c",
            fontWeight: 600,
          }}
        >
          ⚠ This is a demo payment gateway.
        </div>

        <button
          onClick={handlePayNow}
          style={{
            width: "100%",
            marginTop: 20,
            padding: 14,
            background: "#22c55e",
            border: "none",
            borderRadius: 12,
            color: "#fff",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Pay Now
        </button>

      </div>

    </div>

  );
}

export default Payment;